import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import { toast } from "react-toastify";

interface SavePdfState {
    savepdf: {
        load: boolean;
        data: [];
    };
}

export const SavePdfSlice = createSlice({
    name: "savepdf",
    initialState: {
        savepdf: {
            load: false,
            data: [],
        },
    } as SavePdfState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchsavepdf.pending, (state: SavePdfState) => {
                state.savepdf.load = true;
            })
            .addCase(fetchsavepdf.fulfilled, (state: SavePdfState, action: any) => {
                state.savepdf.data = action.payload;
                state.savepdf.load = false;
            })
            .addCase(fetchsavepdf.rejected, (state: SavePdfState) => {
                state.savepdf.load = false;
            });
    },
});

export default SavePdfSlice.reducer;

export const postsavepdf = createAsyncThunk(
    "savepdf/postsavepdf",
    async (param: { apiParam: { project_pin: any, layout_id: any, report: any, showPopup: any, NextTab: any, NextTabValue: any}, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            
            const { data } = await DataServer.post("api/postReportPdfFile", {
                "project_pin": param.apiParam.project_pin,
                "layout_id": param.apiParam.layout_id,
                "report[]": param.apiParam.report
            });

            if(param.apiParam.showPopup === true){                
                thunkAPI.dispatch(toggleLoading());
                toast.success(data.message,{theme: "colored"});
            }

            thunkAPI.dispatch(toggleLoading());
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    }
);

export const fetchsavepdf = createAsyncThunk(
    "savepdf/fetchsavepdf",
    async (param: { apiParam: { project_pin: any, layout_id: any, report: any } }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post("api/getReportPdfFile", {
                project_pin: param.apiParam.project_pin,
                layout_id: param.apiParam.layout_id,
                report: param.apiParam.report
            });
            thunkAPI.dispatch(toggleLoading());
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    }
);

export const generateBackendPdf = createAsyncThunk(
    "savepdf/postsavepdf",
    async (param: { apiParam: { project_pin: any, login_user_id: any}, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            
            const { data } = await DataServer.post("api/generateBackendPdf", {
                "project_pin": param.apiParam.project_pin,
                "login_user_id": param.apiParam.login_user_id
            });

            thunkAPI.dispatch(toggleLoading());
            toast.success(data.message,{theme: "colored"});

            thunkAPI.dispatch(toggleLoading());
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    }
);
